import $ from 'jquery';

class MobileMenu {
    constructor() {
//        this.siteHeader = $('.site-header');
        this.menuIcon = $('.menu-icon');
        this.menuContent = $('.menu');
        this.events();
    }

    events() {
        this.menuIcon.click(this.toggleTheMenu.bind(this));
    }

    toggleTheMenu() {
        this.menuContent.toggleClass('menu--open');
        /* Ha itt this.menuContent-et használok akkor az nem leszjó mert nem az objektumra fog mutatni, mert egy event handleren belül van és ott arra a DOM elementre fog mutatni amit kijelöltünk az event handlerrel, viszont mivel .bind(this)-t használtunk az events-ben ezért itt is működni fog */
//        this.siteHeader.toggleClass('site-header--is-expanded');
        this.menuIcon.toggleClass('menu-icon--close-x');
    }
}

export default MobileMenu;
